import type { AnalyticsDriver } from './driver.types';
import { GoogleTagManagerDriver } from './vendors/google/tag-manager.driver.client';

export type AnalyticsDriverFactory = () => AnalyticsDriver;

export interface AnalyticsDriverConfigItem {
	name: string;
	factory: AnalyticsDriverFactory;
}

export const analyticsConfig = {
	// Order matters; events fan out to these drivers in sequence
	drivers: [
		{ factory: () => GoogleTagManagerDriver, name: 'gtm' },
	] as AnalyticsDriverConfigItem[],
};
